import { boolean, mixed, object, string } from "yup";
import i18n from "../../../../locales/i18n";
import { isExists } from "../../../../utils";

export function addressValidation(
  addressLocations: any[],
  eConversion: boolean
) {
  const addressValidationSchema = object({
    isDefaultAddress: boolean().required(
      i18n.t("resources.customers.addresses.valid.select_is_default_address")
    ),
    name: string().required(
      i18n.t("resources.customers.addresses.valid.enter_address_name")
    ),
    detail: string().required(
      i18n.t("resources.customers.addresses.valid.enter_address_detail")
    ),
    nationalityId: string().required(
      i18n.t("resources.customers.addresses.valid.select_nationality")
    ),
    city: mixed().test(
      i18n.t("resources.customers.addresses.valid.select_city"),
      i18n.t("resources.customers.addresses.valid.select_city"),
      function () {
        const filteredLocations = addressLocations.find(
          (location: any) => location.name === "city"
        );

        if (filteredLocations?.data.length > 0) {
          if (isExists(this.parent.city)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    ),
    town: mixed().test(
      i18n.t("resources.customers.addresses.valid.select_town"),
      i18n.t("resources.customers.addresses.valid.select_town"),
      function () {
        if (this.parent.isForeign) return true;

        const filteredLocations = addressLocations.find(
          (location: any) => location.name === "town"
        );
        if (filteredLocations?.data.length > 0) {
          if (isExists(this.parent.town)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    ),
    townShip: mixed().test(
      i18n.t("resources.customers.addresses.valid.select_town_ship"),
      i18n.t("resources.customers.addresses.valid.select_town_ship"),
      function () {
        if (eConversion) {
          return true;
        }
        if (this.parent.isForeign) return true;

        const filteredLocations = addressLocations.find(
          (location: any) => location.name === "townShip"
        );

        if (filteredLocations?.data.length > 0) {
          if (isExists(this.parent.townShip)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    ),
    village: mixed().test(
      i18n.t("resources.customers.addresses.valid.select_village"),
      i18n.t("resources.customers.addresses.valid.select_village"),
      function () {
        if (eConversion) {
          return true;
        }
        if (this.parent.isForeign) return true;

        const filteredLocations = addressLocations.find(
          (location: any) => location.name === "village"
        );

        if (filteredLocations?.data.length > 0) {
          if (isExists(this.parent.village)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    ),
    district: mixed().test(
      i18n.t("resources.customers.addresses.valid.select_district"),
      i18n.t("resources.customers.addresses.valid.select_district"),
      function () {
        if (eConversion) {
          return true;
        }
        if (this.parent.isForeign) return true;

        const filteredLocations = addressLocations.find(
          (location: any) => location.name === "district"
        );

        if (filteredLocations?.data.length > 0) {
          if (isExists(this.parent.district)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    ),
    street: mixed().test(
      i18n.t("resources.customers.addresses.valid.select_street"),
      i18n.t("resources.customers.addresses.valid.select_street"),
      function () {
        if (eConversion) {
          return true;
        }
        if (this.parent.isForeign) return true;

        const filteredLocations = addressLocations.find(
          (location: any) => location.name === "street"
        );

        if (filteredLocations?.data.length > 0) {
          if (isExists(this.parent.street)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    ),
    building: mixed().test(
      i18n.t("resources.customers.addresses.valid.select_building"),
      i18n.t("resources.customers.addresses.valid.select_building"),
      function () {
        if (eConversion) {
          return true;
        }
        if (this.parent.isForeign) return true;

        const filteredLocations = addressLocations.find(
          (location: any) => location.name === "building"
        );

        if (filteredLocations?.data.length > 0) {
          if (isExists(this.parent.building)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    ),
    door: mixed().test(
      i18n.t("resources.customers.addresses.valid.select_door"),
      i18n.t("resources.customers.addresses.valid.select_door"),
      function () {
        if (eConversion) {
          return true;
        }
        if (this.parent.isForeign) return true;

        const filteredLocations = addressLocations.find(
          (location: any) => location.name === "door"
        );

        if (filteredLocations?.data.length > 0) {
          if (isExists(this.parent.door)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    ),
    addressDetail: object().shape({
      // postalCode: string()
      //   .matches(/^[0-9]+$/, "Must be only digits")
      //   .min(5, i18n.t("resources.customers.addresses.valid.equal_5"))
      //   .max(5, i18n.t("resources.customers.addresses.valid.equal_5"))
      //   .test(
      //     i18n.t("resources.customers.addresses.valid.enter_postal_code"),
      //     i18n.t("resources.customers.addresses.valid.enter_postal_code"),
      //     function () {
      //       if (eConversion) {
      //         return true;
      //       }
      //       const schema: any = this;
      //       const { isForeign }: any = schema.from[1].value;

      //       if (isForeign) return true;

      //       return isExists(this.parent.postalCode);
      //     }
      //   ),
      addressTypeId: string().test(
        i18n.t("resources.customers.addresses.valid.select_address_type"),
        i18n.t("resources.customers.addresses.valid.select_address_type"),
        function () {
          if (eConversion) {
            return true;
          }
          // const schema: any = this;
          // const { isForeign }: any = schema.from[1].value;

          // if (isForeign) return true;

          return isExists(this.parent.addressTypeId);
        }
      ),
      // latitude: string().test(
      //   i18n.t("resources.customers.addresses.valid.latitude"),
      //   i18n.t("resources.customers.addresses.valid.latitude"),
      //   function () {
      //     const schema: any = this;
      //     const { isForeign }: any = schema.from[1].value;

      //     if (isForeign) return true;

      //     return isExists(this.parent.latitude);
      //   }
      // ),
      // longitude: string().test(
      //   i18n.t("resources.customers.addresses.valid.longitude"),
      //   i18n.t("resources.customers.addresses.valid.longitude"),
      //   function () {
      //     const schema: any = this;
      //     const { isForeign }: any = schema.from[1].value;

      //     if (isForeign) return true;

      //     return isExists(this.parent.longitude);
      //   }
      // ),
    }),
  });

  return addressValidationSchema;
}
